// extracted by mini-css-extract-plugin
export var box = "GalleryModal-module--box--3ce0e";
export var box_md = "GalleryModal-module--box_md--b1a83";
export var box_xmd = "GalleryModal-module--box_xmd--8acb6";
export var box_flex = "GalleryModal-module--box_flex--cfe90";
export var box_lg = "GalleryModal-module--box_lg--df11d";
export var box_sm = "GalleryModal-module--box_sm--18b42";
export var box_outer = "GalleryModal-module--box_outer--d8222";
export var box_whiteBg = "GalleryModal-module--box_white-bg--d8254";
export var box_noMarginBottom = "GalleryModal-module--box_no-margin-bottom--f391b";
export var box_noPadding = "GalleryModal-module--box_no-padding--cdfac";
export var box_outerGray = "GalleryModal-module--box_outer-gray--0c8de";
export var box_dark = "GalleryModal-module--box_dark--7a1d1";
export var box_zIndex = "GalleryModal-module--box_z-index--00561";
export var box_zIndex6 = "GalleryModal-module--box_z-index-6--8a9c0";
export var box_eventsWithLine = "GalleryModal-module--box_events-with-line--5d00f";
export var box_featuresAo = "GalleryModal-module--box_features-ao--f90f9";
export var box_verticalPaddings = "GalleryModal-module--box_vertical-paddings--e845c";
export var clearP = "GalleryModal-module--clearP--e848d";
export var clearP_vc = "GalleryModal-module--clearP_vc--c74b5";
export var title = "GalleryModal-module--title--75577";
export var navigation = "GalleryModal-module--navigation--27af8";
export var arrow = "GalleryModal-module--arrow--45fc2";
export var prev = "GalleryModal-module--prev--fa665";
export var next = "GalleryModal-module--next--8b721";
export var amount = "GalleryModal-module--amount--07aac";
export var sliderControls = "GalleryModal-module--sliderControls--e0a84";
export var mobileImageWrapper = "GalleryModal-module--mobileImageWrapper--7a756";
export var bottomSliderWrapper = "GalleryModal-module--bottomSliderWrapper--4e4c2";
export var figure = "GalleryModal-module--figure--000d4";
export var img = "GalleryModal-module--img--399aa";
export var imgBig = "GalleryModal-module--imgBig--322eb";
export var withBottomSlider = "GalleryModal-module--withBottomSlider--e6548";
export var imgCaption = "GalleryModal-module--imgCaption--ffafc";
export var fadeInAnimation = "GalleryModal-module--fadeInAnimation--4dc01";
export var placeHolderShimmer = "GalleryModal-module--placeHolderShimmer--ea287";